import Vue from 'vue';

import './attendant-tagging';
import './audit-trail';
import './common';
import './custom-receipt';
import './customer';
import './customer-engagement';
import './dashboard';
import './franchise-inventory';
import './inventory';
import './item';
import './logo';
import './loyalty';
import './order-layout';
import './outlet';
import './profile';
import './promotion';
import './report';
import './report-wizard';
import './restriction';
import './role';
import './royalty';
import './setting';
import './shelf-space-plan';
import './snapshot';
import './staff';
import './staff/role';
import './transaction';
import './user';
import './voided';

Vue.component('receipt', () => import('./receipt/receipt.vue'));

Vue.component('receipt-ph', () => import('./receipt-ph/receipt.vue'));

Vue.component('region-list', () => import('./region/region-list.vue'));

Vue.component('trading-area-list', () =>
    import('./trading-area/trading-area-list.vue'),
);

/** Franchise Modifier report Vue Element*/

Vue.component('zone-list', () => import('./zone/zone-list.vue'));
